// extracted by mini-css-extract-plugin
export default {"wrapper":"Hea","container":"Iea","box":"Jea","title":"Kea","rdwrap":"Lea","rditem":"Mea","rdimage":"Nea","name":"Oea","heading":"Pea","text":"Qea","guarantee":"Rea","chatbox":"Sea"};
    if(module.hot) {
      // 1721922369176
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  